<sd-heading></sd-heading>

<sd-order-history-filter></sd-order-history-filter>

@switch (orderListType()) {
  @case (orderListTypes.Online) {
    <sd-online-orders-list [hideFilter]="true"></sd-online-orders-list>
  }
  @case (orderListTypes.Offline) {
    <sd-offline-orders-list></sd-offline-orders-list>
  }
}
